import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin, Users, Star } from 'lucide-react';
import { Button } from '../ui/button';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?w=1920"
          alt="Himalayan Mountains"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
      </div>
      

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-24">
        <div className="max-w-3xl">
          <div className="flex items-center gap-2 mb-6">
            <MapPin className="h-5 w-5 text-emerald-400" />
            <span className="text-emerald-400 font-medium">Manali, Himachal Pradesh</span>
          </div>

          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
            Where Every Peak
            <span className="block mt-2 bg-gradient-to-r from-emerald-400 to-teal-400 bg-clip-text text-transparent">
              Holds a Story
            </span>
          </h1>

          <p className="text-xl text-white/80 mb-8 leading-relaxed max-w-2xl">
            Embark on life-changing adventures with Magic Mountain Adventures. 
            From thrilling treks to peaceful nature retreats, discover the magic of the Himalayas.
          </p>

          <div className="flex flex-wrap gap-4">
            <Link to="/trekking">
              <Button size="lg" className="bg-emerald-600 hover:bg-emerald-700 text-white px-8 py-6 text-lg rounded-xl group">
                Explore Adventures
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </Link>
            <Link to="/contact">
              <Button size="lg" variant="outline" className="border-white/30 text-white hover:bg-white/10 px-8 py-6 text-lg rounded-xl">
                Contact Us
              </Button>
            </Link>
          </div>

          {/* Stats */}
          <div className="flex flex-wrap gap-8 mt-16">
            {[
              { value: '15+', label: 'Tour Packages' },
              { value: '25+', label: 'Years Experience' },
              { value: '100%', label: 'Safety Record' },
            ].map((stat, i) => (
              <div key={i} className="text-center">
                <p className="text-4xl font-bold text-white">{stat.value}</p>
                <p className="text-white/60 mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
